import React, { useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';

export interface TabListItem {
  content: React.ReactElement
  label: string;
}

export interface TabListProps {
  tabIndex: string;
  tabLabel?: string;
  className?: string;
  tabItems: TabListItem[];
  handleChange: (event: React.SyntheticEvent, value: any) => void;
};

const TabListComponent = ({
  tabIndex,
  tabItems,
  tabLabel = 'tab list',
  handleChange,
  className = ''
}: TabListProps) => {

  return (
    <TabContext value={tabIndex}>
      <TabList
        onChange={handleChange}
        aria-label={tabLabel}
        className={className}
        data-testid="tab-list-component"
      >
        {
          tabItems
            .map(({ label }: TabListItem, index) => (
              <Tab label={label} value={`${index + 1}`} key={index + label} data-testid={`tab-${index}`} />
            ))
        }
      </TabList>
      {
        tabItems
          .map(({ content, label }: TabListItem, index) => (
            <TabPanel
              value={`${index + 1}`}
              key={`${index}-content-${label}`}
              data-testid={`tab-panel-${index}`}
            >
              {content}
            </TabPanel>
          ))
      }
    </TabContext>
  )
}

export default TabListComponent;
